import { Component } from '@angular/core';

@Component({
  selector: 'app-forgot-password-invalid-token',
  templateUrl: './forgot-password-invalid-token.component.html',
  styles: [
  ]
})
export class ForgotPasswordInvalidTokenComponent {

}
